import { MemberApplication, MemberApplicationDefaults } from "../entity";

interface MemberApplicationList {
    applications?: MemberApplication[];
    loaded?: Boolean;
}
const MemberApplicationListDefaults: MemberApplicationList = {
    applications: [],
    loaded: false
}

export {
    MemberApplicationList,
    MemberApplicationListDefaults
}
